export default __webpack_public_path__ + "static/media/list.fcad07a2.svg";